import React, { Component } from 'react';
import SelectionPopover from 'react-selection-popover';
import { Button } from 'reactstrap';
import Slider from 'react-slick';

import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
import language from '../../../../assets/languages/language';
import Loader from '../../../../common/loader';
import CBTFinishTest from '../../../Common/CBTFinishTest';
import CBTNonAttempted from '../../../Common/CBTNonAttempted';
import CBTFlagged from '../../../Common/CBTFlagged';
import 'sweetalert2/dist/sweetalert2.css';
import { showSuccess } from '../../../../common/toast';
import { questionsettings } from '../../../../common/cbtleftnavigationsettings';
import { clearSelection, highlightString } from '../../../../common/highlightText';
import { filterObj, frmOptionsArr, SecondsToHHMMSS } from '../../../../common/constant';
import { renderHTMLContent } from '../../../../common/function';
/* eslint-disable*/
class CFAQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionsData: [],
      isLoading: true,
      isDataLoading: true,
      token: '',
      idname: '',
      choice_border_a: 'border-black',
      choice_border_b: 'border-black',
      choice_border_c: 'border-black',
      choice_border_d: 'border-black',
      userStatsData: '',
      time: {},
      seconds: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
      showFinishTestPopup: false,
      mockName: '',
      flag: [],
      showSectionReview: false,
      showAttempted: false,
      showUnattempted: false,
      showFlagged: false,
      filter: [],
      showNonAttemptedPopup: false,
      showFlaggedPopup: false,
      selectedQuestionData: [],
      runDecrement: true,
      isNegative: false,
      timerStart: this.props.params.timerStart,
      highlights: [],
      showPopover: false,
      strikeThroughArr: [],
    };
    this.longPressCountdown = null;
    this.timer = 0;
    this.countDown = this.countDown.bind(this);
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  getQuestions = (data) => {
    this.setState({
      isDataLoading: true,
    });
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let highlightdata = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getFRMMockQuestions', data).then((resp) => {
      if (resp.success) {
        this.getHighlightedText(highlightdata);
        this.getStrikedText(highlightdata);

        this.setState({
          questionsData: resp.question,
          selectedQuestionData: resp.question[this.props.params.offset],
          isLoading: false,
          isDataLoading: false,
        });
      } else {
        this.setState({
          isLoading: false,
          isDataLoading: false,
        });
      }
    });
  };

  getUserStats = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getUsersStats', data).then((resp) => {
      if (resp.success) {
        this.setState({
          userStatsData: resp.data,
          seconds: resp.data.user_time_value
            ? resp.data.user_time_value
            : parseInt(this.props.params.timer),
          isNegative: resp.data.isNegative,
        });
        let userChoice =
          resp.data && resp.data.questions && resp.data.questions
            ? JSON.parse(resp.data.questions)
            : '';
        // console.log('resp.data',resp.data);
        for (const i in userChoice) {
          if (i === this.props.params.questiono) {
            if (userChoice[i] === 'choice_a') {
              this.setState({
                choice_border_a: 'border-yellow',
              });
            } else if (userChoice[i] === 'choice_b') {
              this.setState({
                choice_border_b: 'border-yellow',
              });
            } else if (userChoice[i] === 'choice_c') {
              this.setState({
                choice_border_c: 'border-yellow',
              });
            } else {
              this.setState({
                choice_border_d: 'border-yellow',
              });
            }
          }
        }
      } else {
        this.setState({
          isLoading: false,
        });
      }
    });
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    this.getQuestions(data);
    this.getUserStats();
    this.getFlagQuestions();
    if (this.props.params.timerStart === 'true') {
      this.timer = setInterval(this.countDown, 1000);
    } else {
      clearInterval(this.timer);
    }

    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getMockNamebyId', data).then(
      async (res) => {
        this.setState({
          mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
        });
      },
    );
  };

  changeQuestion = (questionNumber, index) => {
    this.slider.slickGoTo(index - 1);
    this.setDefaultBorderColor();
    this.getUserStats();
    this.getFlagQuestions();
    if (questionNumber) {
      this.context.router.push({
        pathname: `/frm/cbtquestions/${this.props.params.id}/${questionNumber}/${
          this.props.params.timer
        }/${this.props.params.level}/${this.props.params.testid}/${index}/${
          this.props.params.isNegative
        }/${this.props.params.timerStart}`,
      });
    }
  };

  getPrevious = (index) => {
    this.slider.slickGoTo(index - 2);
    const { questionsData } = this.state;
    this.setDefaultBorderColor();
    this.getUserStats();
    this.getFlagQuestions();
    this.context.router.push({
      pathname: `/frm/cbtquestions/${this.props.params.id}/${
        this.props.params.offset ? questionsData[parseInt(this.props.params.offset) - 1].id : 1
      }/${this.props.params.timer}/${this.props.params.level}/${this.props.params.testid}/${
        this.props.params.offset ? parseInt(this.props.params.offset) - 1 : 1
      }/${this.props.params.isNegative}/${this.props.params.timerStart}`,
    });
  };

  componentDidUpdate = (prevProps) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (prevProps.params.offset !== this.props.params.offset) {
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
        level: this.props.params.level ? parseInt(this.props.params.level) : null,
      };
      this.getQuestions(data);
    }
  };

  getNext = (index) => {
    this.slider.slickGoTo(index);
    const { questionsData } = this.state;
    this.setDefaultBorderColor();
    this.getFlagQuestions();
    this.getUserStats();
    this.context.router.push({
      pathname: `/frm/cbtquestions/${this.props.params.id}/${
        this.props.params.offset ? questionsData[parseInt(this.props.params.offset) + 1].id : 1
      }/${this.props.params.timer}/${this.props.params.level}/${this.props.params.testid}/${
        this.props.params.offset ? parseInt(this.props.params.offset) + 1 : 1
      }/${this.props.params.isNegative}/${this.props.params.timerStart}`,
    });
  };

  updateSelectedChoice = (userData, selectedQuestionData, choice) => {
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/updateUsersChoice', userData).then(
      async (res) => {
        if (res.success) {
          const ansData = {
            token: this.state.token,
            idname: this.state.idname,
            mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
            question_id: selectedQuestionData.id,
            answer:
              selectedQuestionData && selectedQuestionData.answer === choice
                ? 'correct'
                : 'incorrect',
            level: this.props.params.level ? parseInt(this.props.params.level) : null,
            test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
            reading_id: selectedQuestionData.chapter_id,
          };
          this.getUserStats();
          FD.callAPI(App_data.backend_api + '/frmCBTMockExams/updateUserAnswer', ansData).then(
            async (res) => {},
          );
        }
      },
    );
  };

  setDefaultBorderColor = () => {
    this.setState({
      choice_border_a: 'border-black',
      choice_border_b: 'border-black',
      choice_border_c: 'border-black',
      choice_border_d: 'border-black',
    });
  };

  countDown() {
    const { runDecrement } = this.state;
    let seconds;
    if (this.state.seconds != 0 && runDecrement && this.props.params.isNegative === 'true') {
      seconds = this.state.seconds - 1;
    } else {
      seconds = this.state.seconds + 1;
      this.context.router.push({
        pathname: `/frm/cbtquestions/${this.props.params.id}/${this.props.params.questiono}/${
          this.props.params.timer
        }/${this.props.params.level}/${this.props.params.testid}/${
          this.props.params.offset
        }/false/${this.props.params.timerStart}`,
      });
      this.setState({
        runDecrement: false,
      });
    }
    this.setState({
      seconds: seconds,
    });
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      timer: seconds,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      isNegative: this.props.params.isNegative,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/updateUserTimer', data).then(
      async (res) => {
        if (res.success) {
        }
      },
    );
  }

  submitTest = () => {
    const { questionsData } = this.state;
    this.setState({
      showFinishTestPopup: false,
    });
    const ansdata = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getrightAnswer', ansdata).then(
      (resp_count) => {
        if (resp_count.success) {
          const data = {
            token: this.state.token,
            idname: this.state.idname,
            mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
            score: resp_count.allrightanswercount.question_count,
            level: this.props.params.level ? parseInt(this.props.params.level) : null,
            id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
          };
          FD.callAPI(App_data.backend_api + '/frmCBTMockExams/updateUserScore', data);
        } else {
          //console.log(resp_count.success + '------------failure');
        }
      },
    );
    this.context.router.push({
      pathname: `/frm/cbtquestionsfinish/${this.props.params.id}/${
        questionsData.length && questionsData[0] && questionsData[0].id ? questionsData[0].id : 1
      }/${this.props.params.timer}/${this.props.params.level}/${this.props.params.testid}/0`,
    });
  };

  flagQuestion = (data) => {
    const { flag } = this.state;
    let flaggedQuestions = flag.filter((flag) => flag.question_id === data.id)[0];
    const flagdata = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: data.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    if (flaggedQuestions) {
      showSuccess('Question Unflagged');
    } else {
      showSuccess('Question Flagged');
    }
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/flagQuestion', flagdata).then(
      async (res) => {
        if (res) {
          this.getFlagQuestions();
        }
      },
    );
  };

  getFlagQuestions = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getflaggedQuestions', data).then(
      async (res) => {
        if (res) {
          this.setState({ flag: res.data });
        }
      },
    );
  };

  changeFilter = (e, type) => {
    const { target } = e;
    const { checked } = target;
    const { filter } = this.state;
    if (checked) {
      let temp = [...filter];
      temp.push(type);
      this.setState({
        filter: temp,
      });
    } else {
      // to uncheck elements
      let prevArray = filter.filter((item) => item !== type);
      //console.log('prevArray', prevArray);
      this.setState({
        filter: prevArray,
      });
    }
  };
  finishTest = () => {
    const { flag, userStatsData, questionsData } = this.state;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    if (flag && flag.length) {
      this.setState({
        showFlaggedPopup: true,
      });
    } else if (Object.keys(userChoice).length !== questionsData.length) {
      this.setState({
        showNonAttemptedPopup: true,
      });
    } else {
      this.setState({ showFinishTestPopup: true });
    }
    //api to update status of quiz
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      status: 'completed',
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/updateUserQuizStatus', data).then(
      async (res) => {
        if (res.success) {
        }
      },
    );
  };

  pad = (num) => {
    return ('0' + num).slice(-2);
  };
  SecondsToHHMMSS = (sec) => {
    let hours = Math.floor(sec / (60 * 60));

    let divisor_for_minutes = sec % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);
    return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
  };
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  stopTimer = () => {
    const { timerStart } = this.state;
    if (timerStart === 'true') {
      this.setState({
        timerStart: 'false',
      });
      this.context.router.push({
        pathname: `/frm/cbtquestions/${this.props.params.id}/${this.props.params.questiono}/${
          this.props.params.timer
        }/${this.props.params.level}/${this.props.params.testid}/${this.props.params.offset}/${
          this.props.params.isNegative
        }/false`,
      });
      clearInterval(this.timer);
    } else {
      this.setState({
        timerStart: 'true',
      });
      this.context.router.push({
        pathname: `/frm/cbtquestions/${this.props.params.id}/${this.props.params.questiono}/${
          this.props.params.timer
        }/${this.props.params.level}/${this.props.params.testid}/${this.props.params.offset}/${
          this.props.params.isNegative
        }/true`,
      });
      this.timer = setInterval(this.countDown, 1000);
    }
  };
  addHighlight = async (text) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const { selectedQuestionData } = this.state;
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: selectedQuestionData.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      type: 'highlight',
      text: text,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    await FD.callAPI(App_data.backend_api + '/frmCBTMockExams/addHighlightedText', data).then(
      async (res) => {
        this.setState({ showPopover: false });
        await this.getHighlightedText();
        clearSelection();
      },
    );
  };

  deleteHighlight = async (id) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: id,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };

    if (id) {
      await FD.callAPI(App_data.backend_api + '/frmCBTMockExams/deleteHighlightedText', data).then(
        async (res) => {
          this.setState({ showPopover: false });
          await this.getHighlightedText();
          clearSelection();
        },
      );
    } else {
      return;
    }
  };

  getHighlightedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getHighlightedText', data).then(
      async (res) => {
        this.setState({
          highlights: res.questions,
        });
      },
    );
  };

  clickOption = async (choice, questionId, selectedQuestionData, e) => {
    //console.log('e. type ___________', e.type);
    e.preventDefault();
    // on left click
    if (e.type === 'click') {
      //console.log('Left click');
      const userData = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
        choice: choice,
        questionId: questionId,
        id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
        offset: this.props.params.offset ? parseInt(this.props.params.offset) : null,
        level: this.props.params.level ? parseInt(this.props.params.level) : null,
      };
      this.updateSelectedChoice(userData, selectedQuestionData, choice);
    } else if (e.type === 'contextmenu') {
      //console.log('Right click');
      //on right click
      this.addStrikeThroughOption(choice);
    }
  };

  addStrikeThroughOption = async (choice) => {
    //console.log('I am here ');
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const { selectedQuestionData } = this.state;

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: selectedQuestionData.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      choice: choice,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };

    await FD.callAPI(App_data.backend_api + '/frmCBTMockExams/addStrikeThrough', data).then(
      async (res) => {
        //console.log('resssssssssssssssss', res);
        await this.getStrikedText();
        // clearSelection();
      },
    );
  };

  getStrikedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getStrikedText', data).then(async (res) => {
      if (res && res.questions) {
        this.setState({
          strikeThroughArr: JSON.parse(res.questions.choiceArray),
        });
      } else {
        this.setState({
          strikeThroughArr: [],
        });
      }
    });
  };

  addHighlightToText = () => {
    let text = this.getSelectionHtml();
    this.addHighlight(text);
  };

  deleteHighlightFromText = () => {
    let text = this.getSelectionHtml();

    const { highlights } = this.state;
    let getHighlightedTextData = highlights
      ? highlights.filter((item) => {
          return item.text === text;
        })[0]
      : [];

    this.deleteHighlight(getHighlightedTextData.id);
  };

  getSelectionHtml = () => {
    var html = '';
    if (typeof window.getSelection != 'undefined') {
      var sel = window.getSelection();
      if (sel.rangeCount) {
        var container = document.createElement('div');
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        html = container.innerHTML;
      }
    } else if (typeof document.selection != 'undefined') {
      if (document.selection.type == 'Text') {
        html = document.selection.createRange().htmlText;
      }
    }
    return html;
  };

  ///------------------------------------------------
  // for IOS
  onTouchStart = (e, choice) => {
    e.preventDefault();
    // console.log(' window.navigator', window.navigator);
    const data = this.getMobileOperatingSystem();
    //console.log('datadata', data);
    if (data === 'Android') {
      return;
    } else {
      this.longPressCountdown = setTimeout(() => {
        //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
        this.addStrikeThroughOption(choice);
      }, longPressDuration);
    }
  };

  onTouchMove = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchCancel = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchEnd = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  ///-------------------------------------------------
  render() {
    const {
      isLoading,
      questionsData,
      showFinishTestPopup,
      userStatsData,
      mockName,
      flag,
      showSectionReview,
      showNonAttemptedPopup,
      showFlaggedPopup,
      filter,
      selectedQuestionData,
      isDataLoading,
      seconds,
      timerStart,
      highlights,
      strikeThroughArr,
    } = this.state;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    const formatTimeF = SecondsToHHMMSS(seconds);
    let flaggedQuestion = flag.filter((flag) => flag.question_id === selectedQuestionData.id)[0];
    const sliderSettings = questionsettings(
      this.props.params.offset ? parseInt(this.props.params.offset) : 1,
    );
    let content = selectedQuestionData.question;
    if (highlights) {
      highlights.forEach((element) => {
        content = highlightString(content, element.text);
      });
    }
    let text = this.getSelectionHtml();
    let highlighted = `<b style="background-color: yellow" title="highlighted">${text}</b>`;
    let getHighlightedText = content ? content.indexOf(highlighted) : null;

    // console.log('content', content);
    return (
      <div>
        <div className='animated fadeIn'>
          <div className='margin_bottom_20 ques-title-wrapper'>
            <h1 className='section_head'>{mockName}</h1>
            <div className='finish-btn-wrapper'>
              <Button onClick={() => this.finishTest()} className='pointer_class btn-primary'>
                {language.LC().Finish_Test}
              </Button>
            </div>
          </div>
          {isLoading ? (
            <Loader />
          ) : questionsData && questionsData.length ? (
            <div>
              <div className='row '>
                <div className='qus-tab-wrapper'>
                  <Slider
                    {...sliderSettings}
                    ref={(slider) => {
                      this.slider = slider;
                    }}
                  >
                    {questionsData.map((item, index) => {
                      let flaggedQuestions = flag.filter((flag) => flag.question_id === item.id)[0];
                      return (
                        <div className='slide-button' key={index}>
                          <Button
                            key={index}
                            onClick={() => this.changeQuestion(item.id, index)}
                            className={`
                        ${index === parseInt(this.props.params.offset) ? 'active' : ''}
                        ${userChoice[item.id] ? 'completed-qus' : ''}
                        ${flaggedQuestions ? 'flag-add' : ''}
                        `}
                          >
                            {index + 1}
                            {flaggedQuestions ? (
                              <img
                                width='70'
                                src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                                alt='Question'
                              />
                            ) : (
                              ''
                            )}
                          </Button>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
                <div className='ques-detail-wrapper col-md-12 question-wrapper'>
                  {isDataLoading ? (
                    <Loader />
                  ) : (
                    <div className='card'>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-8 col-lg-9'>
                            {/* <div className="card-header d-flex justify-content-between qus-header"> */}
                            {selectedQuestionData && selectedQuestionData.question ? (
                              <div className='qus-wrapper ques-bold-remove d-block'>
                                <div>
                                  <img
                                    src={
                                      App_data.frontend_url +
                                      '/img/question_bank/question_icon_blue.svg'
                                    }
                                    className='margin_right_20'
                                    alt=''
                                    width='30'
                                  />
                                  Q.{parseInt(this.props.params.offset) + 1}
                                </div>
                                <div
                                  style={{
                                    position: 'relative',
                                    marginTop: '8px',
                                    // maxWidth: "100%",
                                  }}
                                >
                                  <div data-selectable>
                                  {renderHTMLContent(selectedQuestionData.question, "div", "qus-title d-inline-block w-100")}
                                  </div>
                                  <SelectionPopover
                                    showPopover={this.state.showPopover}
                                    onSelect={() => {
                                      this.setState({ showPopover: true });
                                    }}
                                    onDeselect={() => {
                                      this.setState({ showPopover: false });
                                    }}
                                  >
                                    {getHighlightedText === -1 ? (
                                      <div className='highlight-popover tooltip_wrap'>
                                        <img
                                          src={App_data.frontend_url + '/img/high-edit-ico.svg'}
                                          alt='523'
                                          width='30'
                                          onClick={() => this.addHighlightToText()}
                                        />
                                        <div className='tootip_box'>
                                          {language.LC().Click_me_to_highlight}
                                        </div>
                                      </div>
                                    ) : (
                                      <div className='highlight-popover tooltip_wrap'>
                                        <img
                                          src={App_data.frontend_url + '/img/icon_select_text.png'}
                                          alt='523'
                                          width='30'
                                          onClick={() => this.deleteHighlightFromText()}
                                        />
                                        <div className='tootip_box'>
                                          {language.LC().Click_me_to_unhighlight}
                                        </div>
                                      </div>
                                    )}
                                  </SelectionPopover>
                                </div>
                              </div>
                            ) : null}
                            {/* </div> */}

                            <div className='row'>
                              {frmOptionsArr.map((item, index) => {
                                return (
                                  <div
                                    className='col-sm-12'
                                    id={item}
                                    key={index}
                                    onClick={(e) => {
                                      this.clickOption(
                                        item,
                                        selectedQuestionData && selectedQuestionData.id
                                          ? selectedQuestionData.id
                                          : null,
                                        selectedQuestionData,
                                        e,
                                      );
                                    }}
                                    onContextMenu={(e) => {
                                      this.clickOption(
                                        item,
                                        selectedQuestionData && selectedQuestionData.id
                                          ? selectedQuestionData.id
                                          : null,
                                        selectedQuestionData,
                                        e,
                                      );
                                    }}
                                    onTouchStart={(e) => {
                                      this.onTouchStart(e, item);
                                    }}
                                    onTouchCancel={(e) => {
                                      this.onTouchCancel(e);
                                    }}
                                    onTouchEnd={(e) => {
                                      this.onTouchEnd(e);
                                    }}
                                    onTouchMove={(e) => {
                                      this.onTouchMove(e);
                                    }}
                                  >
                                    <div
                                      className={`answer_box ${
                                        userChoice[selectedQuestionData.id] === item
                                          ? `border-yellow`
                                          : 'border-black'
                                      }`}
                                    >
                                      <div
                                        className={`answer_count highlight_choice no-selection ${
                                          item === 'choice_a'
                                            ? strikeThroughArr.includes('choice_a')
                                              ? 'strikethrough'
                                              : ''
                                            : item === 'choice_b'
                                              ? strikeThroughArr.includes('choice_b')
                                                ? 'strikethrough'
                                                : ''
                                              : item === 'choice_c'
                                                ? strikeThroughArr.includes('choice_c')
                                                  ? 'strikethrough'
                                                  : ''
                                                : item === 'choice_d'
                                                  ? strikeThroughArr.includes('choice_d')
                                                    ? 'strikethrough'
                                                    : ''
                                                  : ''
                                        }`}
                                      >
                                        {item === 'choice_a'
                                          ? language.LC().A
                                          : item === 'choice_b'
                                            ? language.LC().B
                                            : item === 'choice_c'
                                              ? language.LC().C
                                              : language.LC().D}
                                      </div>
                                      <p
                                        className={`ans_box_text ${
                                          item === 'choice_a'
                                            ? strikeThroughArr.includes('choice_a')
                                              ? 'strikethrough'
                                              : ''
                                            : item === 'choice_b'
                                              ? strikeThroughArr.includes('choice_b')
                                                ? 'strikethrough'
                                                : ''
                                              : item === 'choice_c'
                                                ? strikeThroughArr.includes('choice_c')
                                                  ? 'strikethrough'
                                                  : ''
                                                : item === 'choice_d'
                                                  ? strikeThroughArr.includes('choice_d')
                                                    ? 'strikethrough'
                                                    : ''
                                                  : ''
                                        }`}
                                      >
                                        {selectedQuestionData && selectedQuestionData[item] ? (
                                         renderHTMLContent(selectedQuestionData[item], "span")
                                        ) : null}
                                        <div className='tootip_box'>
                                          {language.LC().Correct_Choice}
                                        </div>
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div className='col-sm-4 col-lg-3'>
                            <div className='timer_outer mb-15'>
                              <div>
                                <h2 className='time-left-heading'>{language.LC().TIME_LEFT}</h2>
                                <span
                                  className={`timer_box ${
                                    this.props.params.isNegative === 'false' ? 'blink' : null
                                  }`}
                                >
                                  {this.props.params.isNegative === 'false'
                                    ? `- ${formatTimeF}`
                                    : formatTimeF}
                                </span>
                              </div>
                            </div>
                            <button
                              type='button'
                              aria-label={timerStart === 'true' ? 'Pause timer and take a break' : 'Resume timer'}
                              className={`tooltip_wrap mb-2 hover-pad-same
                                ${
                                  timerStart === 'true'
                                    ? 'icon-control-pause pause_btn'
                                    : 'pause_btn icon-control-play'
                                }`}
                              onClick={() => this.stopTimer()}
                            >
                              <div className='tootip_box' aria-hidden='true'>{language.LC().Save_and_Take_Break}</div>
                            </button>
                          </div>
                          <div className='col-sm-3 d-sm-flex align-items-end text-center text-sm-left mt-1'>
                            <button
                              type='button'
                              aria-label={language.LC().SECTION_REVIEW}
                              className='menu-btn tooltip-hover-questions'
                              onClick={() => {
                                this.setState({
                                  showSectionReview: true,
                                });
                              }}
                            >
                              <img
                                width='30px'
                                src={App_data.frontend_url + '/img/questions/icon_menu.png'}
                                className='my-1'
                                alt=''
                              />
                              <div className='tootip_box' aria-hidden='true'>{language.LC().SECTION_REVIEW}</div>
                            </button>
                          </div>
                          <div className='col-sm-9 mt-1'>
                            <div className='text-center text-sm-right btm-btn-wrapper'>
                              <span className='up tooltip-hover-questions '>
                                {flaggedQuestion ? (
                                  <div className='tootip_box'>
                                    {language.LC().UNFLAG_THIS_QUESTION}
                                  </div>
                                ) : (
                                  <div className='tootip_box'>
                                    {language.LC().FLAG_THIS_QUESTION}
                                  </div>
                                )}
                                <i
                                  onClick={() => this.flagQuestion(selectedQuestionData)}
                                  className={
                                    flaggedQuestion
                                      ? `fa fa-flag mark-action-btn`
                                      : `fa fa-flag-o mark-action-btn`
                                  }
                                >
                                  {' '}
                                </i>
                              </span>

                              <Button
                                onClick={() => this.getPrevious(this.props.params.offset)}
                                className='pointer_class btn-primary'
                                disabled={parseInt(this.props.params.offset) === 0}
                              >
                                <i className='fa fa-angle-left' /> {language.LC().BACK}
                              </Button>
                              <Button
                                onClick={() => this.getNext(this.props.params.offset)}
                                className='pointer_class btn-primary'
                                disabled={
                                  parseInt(this.props.params.offset) === questionsData.length - 1
                                }
                              >
                                {language.LC().NEXT} <i className='fa fa-angle-right' />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className='no-qus-found'>
              <img width='105px' src={App_data.frontend_url + '/img/questions/problem.png'} alt='' />
              <h3>{language.LC().NO_QUESTION_FOUND}</h3>
              <p> {language.LC().NO_QUESTION_FOR_THIS_EXAM}</p>
            </div>
          )}
        </div>
        {/* =========For Side Bar S============ */}
        <div className={`sidebar-review-wrapper ${showSectionReview ? 'active' : ''}`}>
          <div className='header-review'>
            <h2>{language.LC().SECTION_REVIEW}</h2>
            <button
              type='button'
              aria-label='Close section review'
              className='section-review-close'
              onClick={() => {
                this.setState({
                  showSectionReview: false,
                });
              }}
            >
              <img width='30px' src={App_data.frontend_url + '/img/questions/icon_close.png'} alt='' />
            </button>
          </div>
          <div className='body-review'>
            <h3>{language.LC().FILTER_BY}:</h3>
            <div className='filt-list-wrapper'>
              <button
                className='btn btn-primary small-btn'
                onClick={() => {
                  this.setState({
                    filter: [],
                  });
                }}
              >
                {language.LC().CLEAR}
              </button>
              <ul>
                {filterObj.map((item, index) => {
                  return (
                    <li className='plan_wrapper remove-plan' key={index}>
                      <label className='check_container'>
                        <input
                          type='checkbox'
                          value={item}
                          id={item}
                          checked={filter.indexOf(item) > -1 ? true : false}
                          onChange={(e) => this.changeFilter(e, item)}
                        />
                        <span className='checkmark' /> {item}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className='qus-tab-wrapper'>
              {questionsData.map((item, index) => {
                let flaggedQuestions = flag.filter((flag) => flag.question_id === item.id)[0];
                return (
                  <div key={index}>
                    {filter.includes('Attempted') &&
                    filter.includes('Unattempted') &&
                    filter.includes('Flagged') ? (
                      <Button
                        className={`${userChoice[item.id] ? 'completed-qus' : ''} ${
                          flaggedQuestions ? 'flag-add' : ''
                        }`}
                        onClick={() => {
                          this.setState({
                            showSectionReview: false,
                          });
                          this.changeQuestion(item.id, index);
                        }}
                      >
                        {index + 1}
                        {flaggedQuestions ? (
                          <img
                            width='70'
                            src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                            alt='Question'
                          />
                        ) : (
                          ''
                        )}
                      </Button>
                    ) : filter.includes('Attempted') && filter.includes('Unattempted') ? (
                      <Button
                        className={`${userChoice[item.id] ? 'completed-qus' : ''}`}
                        onClick={() => {
                          this.setState({
                            showSectionReview: false,
                          });
                          this.changeQuestion(item.id, index);
                        }}
                      >
                        {index + 1}
                      </Button>
                    ) : filter.includes('Unattempted') && filter.includes('Flagged') ? (
                      !userChoice[item.id] && flaggedQuestions ? (
                        <Button
                          className={` ${flaggedQuestions ? 'flag-add' : ''}`}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                          {flaggedQuestions ? (
                            <img
                              width='70'
                              src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                              alt='Question'
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      ) : (
                        ''
                      )
                    ) : ///
                    filter.includes('Attempted') && filter.includes('Flagged') ? (
                      userChoice[item.id] && flaggedQuestions ? (
                        <Button
                          className={`${userChoice[item.id] ? 'completed-qus' : ''} ${
                            flaggedQuestions ? 'flag-add' : ''
                          }`}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                          {flaggedQuestions ? (
                            <img
                              width='70'
                              src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                              alt='Question'
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      ) : (
                        ''
                      )
                    ) : filter.includes('Attempted') ? (
                      userChoice[item.id] ? (
                        <Button
                          className={'completed-qus'}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                        </Button>
                      ) : (
                        ''
                      )
                    ) : filter.includes('Unattempted') ? (
                      !userChoice[item.id] ? (
                        <Button
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                        </Button>
                      ) : (
                        ''
                      )
                    ) : filter.includes('Flagged') ? (
                      flaggedQuestions ? (
                        <Button
                          className={`${
                            userChoice[item.id] ? 'flag-add completed-qus' : 'flag-add '
                          }`}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}

                          <img
                            width='70'
                            src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                            alt='Question'
                          />
                        </Button>
                      ) : (
                        ''
                      )
                    ) : (
                      <Button
                        className={`${userChoice[item.id] ? 'completed-qus' : ''} ${
                          flaggedQuestions ? 'flag-add' : ''
                        }`}
                        onClick={() => {
                          this.setState({
                            showSectionReview: false,
                          });
                          this.changeQuestion(item.id, index);
                        }}
                      >
                        {index + 1}
                        {flaggedQuestions ? (
                          <img
                            width='70'
                            src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                            alt='Question'
                          />
                        ) : (
                          ''
                        )}
                      </Button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* =========For Side Bar E============ */}
        <CBTFinishTest
          showFinishTestPopup={showFinishTestPopup}
          submitTest={() => this.submitTest()}
          handleClose={() => this.setState({ showFinishTestPopup: false })}
        />
        <CBTNonAttempted
          showFinishTestPopup={showNonAttemptedPopup}
          submitTest={() =>
            this.setState({
              showFinishTestPopup: true,
              showNonAttemptedPopup: false,
            })
          }
          handleClose={() => this.setState({ showNonAttemptedPopup: false })}
        />
        <CBTFlagged
          showFinishTestPopup={showFlaggedPopup}
          submitTest={() =>
            this.setState({
              showFlaggedPopup: false,
              showFinishTestPopup: true,
            })
          }
          handleClose={() => this.setState({ showFlaggedPopup: false })}
        />
      </div>
    );
  }
}

export default CFAQuestions;



// WEBPACK FOOTER //
// ./src/views/CBT/FRMCBT/Questions/index.js